<script setup lang="ts">
const verticals = [
  ['migration-agencies', 'Migration agencies'],
  ['education-agencies', 'Education agencies'],
  ['law-firms', 'Law firms'],
  ['real-estate-agencies', 'Real estate agencies'],
]

// Analytics opt-out toggle for the footer link. The plugin reads the same
// localStorage flag and short-circuits before sending anything.
const analytics = useAnalytics()
const optedOut = ref(false)
onMounted(() => { optedOut.value = analytics.isOptedOut() })

const toggleAnalytics = () => {
  if (optedOut.value) {
    analytics.optIn()
    optedOut.value = false
  } else {
    analytics.optOut()
    optedOut.value = true
  }
}
</script>

<template>
  <footer class="mt-24 border-t border-gray-100 bg-gray-50">
    <div class="mx-auto max-w-7xl px-6 py-12 grid grid-cols-2 md:grid-cols-4 gap-8 text-sm">
      <div class="col-span-2">
        <NuxtLink to="/" class="flex items-center gap-2 text-lg font-semibold text-gray-900">
          <span class="inline-block w-7 h-7 rounded bg-gradient-to-br from-indigo-500 to-purple-500"></span>
          Caseflow
        </NuxtLink>
        <p class="mt-3 text-gray-600 max-w-md">
          The operations OS for small services agencies. Replace Excel, Word
          and Outlook with one tool that knows your industry on day one.
        </p>
      </div>
      <div>
        <p class="text-xs uppercase tracking-wide text-gray-500 font-medium mb-3">Verticals</p>
        <ul class="space-y-2">
          <li v-for="[slug, label] in verticals" :key="slug">
            <NuxtLink :to="`/${slug}`" class="text-gray-600 hover:text-gray-900">{{ label }}</NuxtLink>
          </li>
        </ul>
      </div>
      <div>
        <p class="text-xs uppercase tracking-wide text-gray-500 font-medium mb-3">Company</p>
        <ul class="space-y-2">
          <li><NuxtLink to="/pricing" class="text-gray-600 hover:text-gray-900">Pricing</NuxtLink></li>
          <li><NuxtLink to="/blog" class="text-gray-600 hover:text-gray-900">Blog</NuxtLink></li>
          <li><NuxtLink to="/contact" class="text-gray-600 hover:text-gray-900">Contact</NuxtLink></li>
          <li><NuxtLink to="/legal/terms" class="text-gray-600 hover:text-gray-900">Terms</NuxtLink></li>
          <li><NuxtLink to="/legal/privacy" class="text-gray-600 hover:text-gray-900">Privacy</NuxtLink></li>
          <li><NuxtLink to="/login" class="text-gray-600 hover:text-gray-900">Sign in</NuxtLink></li>
        </ul>
      </div>
    </div>
    <div class="border-t border-gray-200 py-4 text-center text-xs text-gray-500 flex items-center justify-center gap-3 flex-wrap">
      <span>© {{ new Date().getFullYear() }} Caseflow. All rights reserved.</span>
      <span class="text-gray-300">·</span>
      <button @click="toggleAnalytics" class="text-gray-500 hover:text-gray-700 underline-offset-2 hover:underline">
        {{ optedOut ? 'Re-enable anonymous analytics' : 'Don\'t track me (anonymous analytics)' }}
      </button>
    </div>
  </footer>
</template>
